import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './to-be-present-explanation';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "tobepresent" },
];

const ToBe = () => (
  <GrammarPageLayout
    level="A1"
    title="Verb 'to be'- Present Simple"
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Exercises: “To Be” Present Tense"
    seoDescription="Practice Verb 'to be'- Present Simple with interactive exercises for A1 level English exams."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default ToBe;
